const ROUTES = {
  ROOT: '/',
  FAQ: '/faq',
  TERMS_CONDITIONS: '/termos-e-condicoes',
  PRIVACY_POLICY: '/politicas-de-privacidade',
}

export default ROUTES
